export const pricingPaths = {
  '/pricing-tables': {
    get: {
      summary: 'List all pricing tables',
      operationId: 'listPricingTables',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter pricing tables by name',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of pricing tables',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/PricingTable',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new pricing table',
      operationId: 'createPricingTable',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/PricingTable',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created pricing table',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/PricingTable',
              },
            },
          },
        },
      },
    },
  },
  '/pricing-tables/{id}': {
    get: {
      summary: 'Get a pricing table by ID',
      operationId: 'getPricingTable',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The requested pricing table',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/PricingTable',
              },
            },
          },
        },
      },
    },
    patch: {
      summary: 'Update a pricing table',
      operationId: 'updatePricingTable',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/PricingTable',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated pricing table',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/PricingTable',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a pricing table',
      operationId: 'deletePricingTable',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '204': {
          description: 'Pricing table deleted successfully',
        },
      },
    },
  },
  '/pricing-tables/{id}/make-default': {
    post: {
      summary: 'Set a pricing table as the default for the system',
      operationId: 'makeDefaultPricingTable',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The pricing table was successfully set as default',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/PricingTable',
              },
            },
          },
        },
      },
    },
  },
  '/pricing-calculate': {
    post: {
      summary: 'Calculate pricing for documents and transaction fees',
      operationId: 'calculatePricing',
      tags: ['Pricing'],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/PricingCalculationRequest',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'Pricing calculation result',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/PricingCalculationResult',
              },
            },
          },
        },
        '400': {
          description: 'Invalid request parameters',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
        '404': {
          description: 'No valid documents found or no pricing table for association',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
  },
};
